import React from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'
import { styles } from './styles'
import StyledIconButton from 'Components/Form/StyledIconButton'

const CoreOutlinedButton = ({
  classes,
  onClick,
  label,
  icon,
  disabled,
  cypress_id,
}) => {
  return (
    <StyledIconButton
      startIcon={icon}
      onClick={onClick}
      className={cn(classes.button, {
        [classes.disabled]: disabled,
      })}
      disabled={disabled}
      cypress_id={cypress_id}
    >
      {label}
    </StyledIconButton>
  )
}

export default injectStyles(styles)(CoreOutlinedButton)
